import { AppBar, Toolbar, Typography } from 'nxg-ui-wrapper';
import * as React from 'react';
import { SystemStyleObject } from '@mui/system';
import { IMG_LOGO } from '../assets';

const TYPO_STYLE: SystemStyleObject = {
    ml: 0.5,
    display: 'flex',
    alignItems: 'center',
};

const Header = (): React.ReactElement => {
    return (
        <AppBar position="static">
            <Toolbar sx={{ paddingLeft: '12px!important' }}>
                <img height="36" src={IMG_LOGO} alt={'hg'} />
                <Typography component="div" sx={TYPO_STYLE}>
                    TOKYO SEIMITSU
                </Typography>
            </Toolbar>
        </AppBar>
    );
};

export default Header;
